<script lang="ts" context="module">
  import { onMount } from "svelte";

  /** 1차 메뉴 */
  export interface IMenuPrimary extends IMenuSecondary {
    /** 2차 메뉴들 */
    children: IMenuSecondary[];
  }

  /** 2차 메뉴 */
  export interface IMenuSecondary {
    /** 메뉴명 */
    name: string;
    /** url */
    link?: string;
  }
</script>

<script lang="ts">
  import {
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
  } from "sveltestrap";

  let isFocused = false;

  /** prop */
  export let item: IMenuPrimary = {} as IMenuPrimary;

  function ev포커스() {
    isFocused = true;
  }

  function ev블러() {
    isFocused = false;
  }

  function toggle_movie(mode) {
    const header = document.getElementById("header");
    const movie_shield = document.getElementById("movie-shield");
    const nav_a = document.getElementsByClassName("nav-a");
    const dropdown_item = document.getElementsByClassName("dropdown-item");
    const dropdown_menu = document.getElementsByClassName("dropdown-menu");
    const header_logo = document.getElementById("header-logo");

    const float_scroll = document.getElementById("float-scroll");
    if (mode == "movie-end") {
      header.style.background = "rgba(255, 255, 255, 0.8)";
      header_logo.src = "/images/ci/bandi.png";
      for (var i = 0; i < nav_a.length; i++) {
        nav_a[i].style.color = "rgba(0,0,0,0.84)";
      }
      for (var i = 0; i < dropdown_item.length; i++) {
        dropdown_item[i].style.color = "rgba(0,0,0,0.84)";
      }
      for (var i = 0; i < dropdown_menu.length; i++) {
        dropdown_menu[i].style.background = "rgba(255,255,255,0.84)";
      }
    } else if (mode == "movie-do") {
      header.style.background = "rgba(255, 255, 255, 0)";
      header_logo.src = "/images/ci/bandi-white.png";
      for (var i = 0; i < nav_a.length; i++) {
        nav_a[i].style.color = "rgba(255,255,255,0.84)";
      }
      for (var i = 0; i < dropdown_item.length; i++) {
        dropdown_item[i].style.color = "rgba(255,255,255,0.84)";
      }
      for (var i = 0; i < dropdown_menu.length; i++) {
        dropdown_menu[i].style.background = "rgba(0,0,0,0)";
      }
    }
  }
  onMount(() => {
    window.onload = function () {
      checkPage();
      setm();

      // nav fadein, out 효과 구현중에 중단
      // var divs = document.getElementsByClassName("nav-a");
      // var divs2 = document.getElementsByClassName("dropdown-menu");
      // for (var i = 0; i < divs.length; i++) {
      //   divs[i].addEventListener("mouseover", (event) => {
      //     event.target.parentElement.parentElement.getElementsByClassName(
      //       "dropdown-menu"
      //     )[0].style.display = "block";
      //     setTimeout(function () {
      //       event.target.parentElement.parentElement.getElementsByClassName(
      //         "dropdown-menu"
      //       )[0].style.opacity = "1";
      //     }, 10);
      //   });
      //   divs2[i].addEventListener("mouseout", (event) => {
      //     event.target.style.opacity = "0";
      //     setTimeout(function () {
      //       event.target.style.display = "none";
      //     }, 300);
      //   });
      // }
    };
  });
  function checkPage() {
    const movie_shield = document.getElementById("movie-shield");

    if (
      window.location.pathname == "/" &&
      window.pageYOffset <= movie_shield.offsetHeight - 116
    ) {
      toggle_movie("movie-do");
    } else {
      toggle_movie("movie-end");
    }
  }
  function setm() {
    var pathname = window.location.pathname;
    if (pathname != "/") {
      var elem = document.getElementsByClassName("menu-title");
      for (var i = 0; i < elem.length; i++) {
        elem[i].getElementsByClassName("nav-a")[0].style.color =
          "rgba(0,0,0,0.84)";
      }
      const m1 = ["news", "video", "press"];

      if (pathname.indexOf("bandiburri") != -1) {
        elem[0].getElementsByClassName("nav-a")[0].style.color = "#a11f1f";
      } else if (pathname.indexOf("service") != -1) {
        elem[1].getElementsByClassName("nav-a")[0].style.color = "#a11f1f";
      } else if (pathname.indexOf("pf") != -1) {
        elem[2].getElementsByClassName("nav-a")[0].style.color = "#a11f1f";
      } else if (m1.includes(pathname.split("/").pop())) {
        elem[3].getElementsByClassName("nav-a")[0].style.color = "#a11f1f";
      } else if (pathname.indexOf("contact") != -1) {
        elem[5].getElementsByClassName("nav-a")[0].style.color = "#a11f1f";
      } else {
        elem[4].getElementsByClassName("nav-a")[0].style.color = "#a11f1f";
      }
    }
  }
  function setMenuColor() {
    setTimeout(function () {
      checkPage();
      setm();
    }, 100);
  }
</script>

<div
  id="wrap"
  on:mouseover={ev포커스}
  on:focus={ev포커스}
  on:mouseout={ev블러}
  on:blur={ev블러}
>
  <Dropdown nav isOpen={isFocused}>
    <div class="menu-title" on:click={setMenuColor}>
      <a href={item.link ?? "#"} class="nav-a">{item.name}</a>
    </div>

    {#if item.children?.length > 0}
      <DropdownMenu
        style="background:rgba(0,0,0,0); border: none; padding-top: 0px; color: rgba(255,255,255,0.8); margin-top: 0px;"
      >
        {#each item.children as e}
          <a href={e.link ?? "#"} class="dropdown-item" on:click={setMenuColor}
            >{e.name}</a
          >
          <!--  <DropdownItem
            href={e.link ?? "#"}
            style="color: rgba(255,255,255,0.84);"
            on:click={setMenuColor}>{e.name}</DropdownItem
          > -->
        {/each}
      </DropdownMenu>
    {/if}
  </Dropdown>
</div>

<style lang="scss">
  a {
    text-decoration: none !important;
  }
  #wrap {
    .menu-title {
      display: block;
      cursor: pointer;
      height: 81px;
      line-height: 81px;
      a {
        color: rgba(255, 255, 255, 0.84);
        display: block;
      }
      &:hover a {
        color: #a11f1f !important;
      }
    }
    .nav-a {
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }
</style>
